import Text from '@zenbusiness/common-components/Text';

import IconButton from '@mui/material/IconButton';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

import { BorderedBox } from '../BorderedBox';

export const MainContainer = superstyled({
  tag: BorderedBox,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.focus00.main,
    borderRadius: '1rem',
    padding: '1.25rem 1.5rem',
    [theme.breakpoints.up('sm')]: {
      borderRadius: '1.5rem'
    }
  })
});

export const WhatDidYouThinkText = superstyled({
  tag: Text,
  styles: {
    fontSize: '1.25rem'
  }
});

export const StyledIconButton = superstyled({
  tag: IconButton,
  styles: {
    padding: '2px',
    color: 'inherit'
  }
});
